import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

import {
  CONTATO_DESTAQUE_BOTAO_ROTULO,
  CONTATO_DESTAQUE_TELEFONE_ROTULO,
  CONTATO_DESTAQUE_TITULO,
} from './helpers';

const messages = defineMessages({
  titleBlock: {
    id: 'mpf_contato_destaque_block',
    defaultMessage: 'Contato em destaque',
  },
  titulo: { id: 'mpf_contato_destaque_titulo', defaultMessage: 'Título' },
  tituloHelp: {
    id: 'mpf_contato_destaque_titulo_help',
    defaultMessage: 'Em branco, usa "{padrao}".',
  },
  texto: { id: 'mpf_contato_destaque_texto', defaultMessage: 'Texto' },
  textoHelp: {
    id: 'mpf_contato_destaque_texto_help',
    defaultMessage: 'Uma ou duas frases dizendo quem atende e para quê.',
  },
  telefone: {
    id: 'mpf_contato_destaque_telefone',
    defaultMessage: 'Telefone',
  },
  telefoneHelp: {
    id: 'mpf_contato_destaque_telefone_help',
    defaultMessage:
      'Como deve aparecer na tela, ex.: "0800 000 5640". O botão disca só os dígitos. Sem telefone, o bloco não aparece na página.',
  },
  telefoneRotulo: {
    id: 'mpf_contato_destaque_telefone_rotulo',
    defaultMessage: 'Rótulo do telefone',
  },
  botaoRotulo: {
    id: 'mpf_contato_destaque_botao_rotulo',
    defaultMessage: 'Rótulo do botão',
  },
  emBranco: {
    id: 'mpf_contato_destaque_em_branco',
    defaultMessage: 'Em branco, usa "{padrao}".',
  },
});

export const mpfContatoDestaqueSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.titleBlock),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['titulo', 'texto', 'telefone', 'telefoneRotulo', 'botaoRotulo'],
    },
  ],
  properties: {
    titulo: {
      title: intl.formatMessage(messages.titulo),
      description: intl.formatMessage(messages.tituloHelp, {
        padrao: CONTATO_DESTAQUE_TITULO,
      }),
      placeholder: CONTATO_DESTAQUE_TITULO,
    },
    texto: {
      title: intl.formatMessage(messages.texto),
      description: intl.formatMessage(messages.textoHelp),
      widget: 'textarea',
    },
    telefone: {
      title: intl.formatMessage(messages.telefone),
      description: intl.formatMessage(messages.telefoneHelp),
      placeholder: '0800 000 5640',
    },
    telefoneRotulo: {
      title: intl.formatMessage(messages.telefoneRotulo),
      description: intl.formatMessage(messages.emBranco, {
        padrao: CONTATO_DESTAQUE_TELEFONE_ROTULO,
      }),
      placeholder: CONTATO_DESTAQUE_TELEFONE_ROTULO,
    },
    botaoRotulo: {
      title: intl.formatMessage(messages.botaoRotulo),
      description: intl.formatMessage(messages.emBranco, {
        padrao: CONTATO_DESTAQUE_BOTAO_ROTULO,
      }),
      placeholder: CONTATO_DESTAQUE_BOTAO_ROTULO,
    },
  },
  required: ['telefone'],
});

export default mpfContatoDestaqueSchema;
